const openBurgerBtn = document.querySelector(".js-open-burger");
const closeBurgerBtn = document.querySelector(".js-close-burger");
const burgerDiv = document.querySelector(".js-burger");
const headerDiv = document.querySelector(".js-header");
const overlayDiv = document.querySelector(".js-overlay");

/*
 *
 * On click, open burger
 *
 */

openBurgerBtn.addEventListener("click", (e) => {
    e.preventDefault();
    closeCat();
    closeSearch();
    openBurger();
});

closeBurgerBtn.addEventListener("click", (e) => {
    e.preventDefault();
    closeBurger();
});
overlayDiv.addEventListener("click", (e) => {
    e.preventDefault();
    closeBurger();
    closeCat();
    closeSearch();
});

function openBurger() {
    burgerDiv.classList.add("is-active");
    headerDiv.classList.add("is-burger-open");
    overlayDiv.classList.add("is-active");
}

function closeBurger() {
    burgerDiv.classList.remove("is-active");
    headerDiv.classList.remove("is-burger-open");
    overlayDiv.classList.remove("is-active");
}
